/** Переключатель языка интерфейса: RU · EN · DE. Выбор сохраняется в браузере. */
import { LANGS, setLang, t, useLang } from '../i18n';

export function LangSwitch({ className = '' }: { className?: string }) {
  const lang = useLang();
  return (
    <div className={`segmented lang-switch ${className}`} role="radiogroup" aria-label={t('common.language')}>
      {LANGS.map((l) => (
        <button key={l.id} type="button" role="radio" aria-checked={lang === l.id} className={lang === l.id ? 'on' : ''} title={l.title} lang={l.id} onClick={() => setLang(l.id)}>
          {l.short}
        </button>
      ))}
    </div>
  );
}
